import { memo, useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'
import styled from 'styled-components'
import { motion, useAnimation, useInView } from 'motion/react'
import { mq, vw, getP50, createUnderline, staggerChildVariants, staggerWrapperVariants, basicVariantsProps } from '@/styles'
import { MODALS } from '@/context'
import { useModal, useTranslator } from '@/hooks'

export const PreFooter = memo(() => {
  const { toggle } = useModal(MODALS.NEWSLETTER)
  const { toggle:openModalContact } = useModal(MODALS.CONTACT)
  const pathname  = usePathname()
  const { t } = useTranslator()
  const controls = useAnimation()
  const ref = useRef(null)
  const isInView = useInView(ref, { margin: '0px 0px -100px 0px' })

  useEffect(() => {
    if(isInView) {
      controls.start('animate')
    }
  }, [controls, isInView])

  return (
    <Aside ref={ref} variants={staggerWrapperVariants} {...basicVariantsProps} animate={controls}>
      {!pathname.includes('colour-tool') ?
        <>
          <motion.p variants={staggerChildVariants} dangerouslySetInnerHTML={{ __html: t('project.prefooter.title') }}></motion.p>
          <motion.button variants={staggerChildVariants} onClick={toggle}>{t('project.prefooter.subscribe')}<span></span></motion.button>
        </>
        :
        <>
          <motion.p variants={staggerChildVariants} dangerouslySetInnerHTML={{ __html: t('project.prefooter.colour_tool') }}></motion.p>
          <motion.button variants={staggerChildVariants} onClick={openModalContact}>{t('project.prefooter.colour_tool_button')}<span></span></motion.button>
        </>
      }
    </Aside>
  )
})

const Aside = styled(motion.aside)`
  text-align: center;
  margin: ${vw(130, 'mobile')} 0;
  width: 100%;

  ${mq.greaterThan('tablet')}{
    margin: ${vw(150, 'desktop')} 0;
  }

  p {
    ${getP50()}
    text-align: center;
    margin-bottom: ${vw(20, 'mobile')};

    ${mq.greaterThan('tablet')}{
      margin-bottom: ${vw(40, 'desktop')};
    }
  }

  button {
    ${createUnderline({ reverse: true })}
  }
`